/* global $ */
import { TweenMax } from 'gsap';

import { createElement, Component, PropTypes } from 'rlink-react';
import themeable from 'rlink-theme/themeable';

import History from 'components/History/History';
import HistoryControlPoint from 'components/History/HistoryControlPoint';
import resizeBackground from 'helpers/sliders/resizeBackground';
import historyScene from 'helpers/scenes/historyScene';
import legacyIsDesktop from 'helpers/legacyIsDesktop';
import historyTooltipScene from 'helpers/scenes/historyTooltipScene';

export default class HistoryPanel extends Component {

  updateHistorySliderImg () {
    Array.from(document.querySelectorAll('.view-history.view-display-id-history_slider .view-content .image img')).forEach(item => {
      resizeBackground(item);
    });
  }

  checkHistoryHighest () {
    let historySlider = document.querySelector('.view-history.view-display-id-history_slider .view-content');

    let t = 0;
    let th = 0;
    let minh = ((window.innerHeight - document.querySelector('#history .section-title').offsetHeight) - 75);

    Array.from(historySlider.querySelectorAll('.wrapper .row  div.ch')).forEach(item =>
      item.setAttribute('style', `min-height: ${minh > 500 ? minh - 140 : t}px`
    ));

    Array.from(document.querySelectorAll('#history .slick-slide .wrapper .body')).forEach(item => {
      let titleBlock = item.parentElement.parentElement.querySelector('.title-block');
      if (item.offsetHeight > t) {
        t = item.offsetHeight;
      }

      if (titleBlock.offsetHeight > th) {
        th = titleBlock.offsetHeight;
      }
    });

    if (!legacyIsDesktop()) {
      t += th;
    }

    Array.from(document.querySelectorAll('#history .slick-slide')).forEach(item => $(item).height('auto'));
    Array.from(document.querySelectorAll('#history .slick-slide article')).forEach(item => $(item).height('auto'));

    if (t < (window.innerHeight - (document.querySelector('#history .section-title').offsetHeight + 40))) {
      document.querySelector('#history > .wrapper').setAttribute('style', `
        width: ${$(window).innerWidth()}px;
        height: ${window.innerHeight - 75}px;
        overflow: hidden;
        position: relative;
      `);
      Array.from(document.querySelectorAll('#history .slick-slide article')).forEach(item => {
        item.setAttribute('style', `height: ${(window.innerHeight - document.querySelector('#history .section-title').offsetHeight - 75)}px;`);
      });
      document.querySelector('#history .slick-slider').setAttribute('style', `height: ${(window.innerHeight - (document.querySelector('#history .section-title').offsetHeight + 75))}px;`);
    } else {
      document.querySelector('#history > .wrapper').setAttribute('style', `
        width: ${$(window).innerWidth()}px;
        height: auto;
        overflow: hidden;
        position: relative;
      `);

      $('#history .slick-slide article').height(t);
      document.querySelector('#history .slick-slider').setAttribute('style', 'height: auto;');
    }

    this.updateHistorySliderImg();

  }

  setSlideControlSelected (currentSlide) {
    let historyView = document.querySelector('.view-history.view-display-id-history_slider');
    this.currentSlideState = currentSlide || 0;
    let prevSlide = historyView.querySelector(`.slick-slide[data-slick-index="${this.currentSlideState - 1}"]`);
    let nextSlide = historyView.querySelector(`.slick-slide[data-slick-index="${this.currentSlideState + 1}"]`);
    let prevTitle = (prevSlide !== null) ? prevSlide.querySelector('.node-title .date-display-single').innerHTML : '';
    let nextTitle = (nextSlide !== null) ? nextSlide.querySelector('.node-title .date-display-single').innerHTML : '';
    let slickPrevButton = historyView.querySelector('.slick-prev');
    let slickNextButton = historyView.querySelector('.slick-next');
    if (slickPrevButton && slickNextButton) {
      slickPrevButton.innerHTML = `<span>${prevTitle}</span>`;
      slickNextButton.innerHTML = `<span>${nextTitle}</span>`;
    }

    historyView.querySelector(`.view-display-id-history_timeline .node-history:nth-child(${currentSlide + 1})`).className += ' select';
    this.checkHistoryHighest();
  }

  initTimelineControls () {
    this.setSlideControlSelected(this.currentSlideState);
    let historyControlButton = Array.from(document.querySelectorAll('.view-history.view-display-id-history_slider .attachment .node-history.node-teaser'));
    historyControlButton.forEach((item, index) => {
      historyControlButton[index].addEventListener('mouseover', () => {
        let el = item.querySelector('.timeline-item');
        TweenMax.fromTo(el, 1, {autoAlpha: 0, y: -20}, {y: 0, autoAlpha: 1});
      });
      historyControlButton[index].addEventListener('click', () => {
        $('#HistorySlider').slick('slickGoTo', index);
      });
    });
  }

  updateDimensions () {
    $('#history .slick-slide').width($(window).innerWidth());
  }

  componentDidMount () {
    this.currentSlideState = 0;
    $('#HistorySlider').slick(this.sliderSettings());

    $('#HistorySlider').on('init afterChange', (_event, _slick, currentSlide, _nextSlide) => {
      this.setSlideControlSelected(currentSlide);
    });
    $('#HistorySlider').on('beforeChange', () => {
      let historyView = document.querySelector('.view-history.view-display-id-history_slider');
      Array.from(historyView.querySelectorAll('.view-display-id-history_timeline .node-history')).forEach(item => {
        item.classList.remove('select');
      });
    });
    $('#HistorySlider').on('setPosition', (_e, _slick, _currentSlide) => {
      this.updateDimensions();
      this.checkHistoryHighest();
    });
    this.initTimelineControls();
    historyScene();
    historyTooltipScene();
  }

  sliderSettings () {
    return {
      autoplay: false,
      arrows: true,
      dots: false,
      infinite: false,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            arrows: false,
          },
        }
      ],
    };
  }

  render () {
    let {theme, historyData} = this.props;
    let sortedHistoryData = historyData.sort((a, b) => Number.parseInt(a.priority) - Number.parseInt(b.priority));
    return (
      <section id="node-10" className="node node-single-page-section node-promoted view-mode-full">
        <article id="history" className="layout-wide clearfix">
          <div className="wrapper">
            <div className="row">
              <div className="section-title bg-white text-black">
                <h2>History</h2>
              </div>
              <div className="view view-history view-id-history view-display-id-history_slider view-dom-id-498ae1a5829f5f7fe82eb02dc123603d">
                <div className="mobile-tooltip">
                  <div className="round-lable">
                    <i />
                    <p>SWIPE TO SCROLL THROUGH THE TIMELINE</p>
                  </div>
                </div>
                <div
                  id="HistorySlider"
                  className={`view-content ${theme.HistorySlider}`}>
                  {sortedHistoryData
                    .map(item => (
                      <History key={item.title} historyData={item} />
                    ))}
                </div>
                <div className="attachment attachment-after">
                  <div className="view view-history view-id-history view-display-id-history_timeline">
                    <div className="view-content">
                      {sortedHistoryData
                        .map(item => (
                          <HistoryControlPoint
                            key={item.title}
                            slidePointTitle={item.year}
                            tooltipMessage={item.title} />
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </section>
    );
  }
}

HistoryPanel.propTypes = {
  historyData: PropTypes.arrayOf(PropTypes.object),
};

themeable(HistoryPanel, {
  classes: [
    'HistorySlider',
  ],
});



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/History/HistoryPanel.jsx